import { INTERNAL_PRECISION } from '../constants';

/**
 * Normalises a value for comparison: rounds numbers (and numeric strings) to
 * INTERNAL_PRECISION decimal places; trims/lowercases/unquotes other strings.
 */
export function normalize(value: string | number): string {
  if (typeof value === 'number') {
    return String(Math.round(value * 10 ** INTERNAL_PRECISION) / 10 ** INTERNAL_PRECISION);
  }
  const trimmed = String(value).trim().toLowerCase().replace(/^["']|["']$/g, '');
  const asNum = Number(trimmed);
  if (trimmed !== '' && !isNaN(asNum)) {
    return String(Math.round(asNum * 10 ** INTERNAL_PRECISION) / 10 ** INTERNAL_PRECISION);
  }
  return trimmed;
}
